<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <div class="px-3 px-sm-0">
      <GmapAutocomplete
        class="v-autocomplete my-autocomplete"
        @place_changed="onPlaceChanged"
        placeholder="Pesquisar cidade ou local"
      />
    </div>

    <div style="flex-grow: 1">
      <GmapMap
        v-if="mapCenter && mapZoom"
        @bounds_changed="onBoundsChanged"
        :class="{ 'rounded-lg overflow-hidden': !smAndDown }"
        ref="gmap"
        :center="mapCenter"
        :zoom="mapZoom"
        map-type-id="satellite"
        style="width: 100%; height: 100%"
      >
        <GmapPolygon
          v-for="(item, index) in fazendas"
          :key="index"
          :paths="convertCoordinates(item.coordinates)"
          :options="polygonOptions"
          @click="onSelectFazenda(item)"
        />

        <GmapMarker
          v-for="(fazenda, index) in fazendas"
          :key="'marker_' + index"
          :position="convertCoordinates(fazenda.coordinates)[0]"
          @click="onSelectFazenda(fazenda)"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
import { server } from "@/config.js";

export default {
  props: {
    fazendas: Array,
  },
  data: () => ({
    timer: null,
    coordinate: null,
    polygonOptions: {
      strokeColor: "yellow",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "transparent",
      fillOpacity: 0.35,
    },
  }),
  computed: {
    domain() {
      if (server.includes("saojose")) return "saojose";
      else if (server.includes("platano")) return "platano";
      else return "fazendas";
    },
    mapZoom() {
      return 4.5;
      // switch (this.domain) {
      //   case "saojose":
      //     return 4.5;
      //   default:
      //     return 10;
      // }
    },
    mapCenter() {
      return { lat: -12.211790985669854, lng: -50.55518439030895 };
      // switch (this.domain) {
      //   case "saojose":
      //     return { lat: -12.211790985669854, lng: -50.55518439030895 };
      //   default:
      //     return { lat: -11.8707624, lng: -55.5475799 };
      // }
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onBoundsChanged() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const bounds = this.$refs.gmap.$mapObject.getBounds();

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();

        const latitudeNE = ne.lat();
        const longitudeNE = ne.lng();
        const latitudeSW = sw.lat();
        const longitudeSW = sw.lng();

        const latitudeNW = ne.lat();
        const longitudeNW = sw.lng();
        const latitudeSE = sw.lat();
        const longitudeSE = ne.lng();

        this.coordinate = [
          { lat: latitudeNE, lng: longitudeNE },
          { lat: latitudeNW, lng: longitudeNW },
          { lat: latitudeSW, lng: longitudeSW },
          { lat: latitudeSE, lng: longitudeSE },
          { lat: latitudeNE, lng: longitudeNE },
        ];

        this.$emit("onGetPositions", {
          latitudeNE,
          longitudeNE,
          latitudeSW,
          longitudeSW,
          latitudeNW,
          longitudeNW,
          latitudeSE,
          longitudeSE,
        });
      }, 500);
    },
    onSelectFazenda(item) {
      let route = this.$router.resolve({
        path: "/portfolio/" + item.fazenda.id,
      });
      window.open(route.href);
    },
    convertCoordinates(coordinates) {
      const polygonCoordinates = coordinates.coordinates[0];

      const coordinatesCount = polygonCoordinates.length;

      let sumX = 0;
      let sumY = 0;

      for (let i = 0; i < coordinatesCount; i++) {
        sumX += polygonCoordinates[i][0];
        sumY += polygonCoordinates[i][1];
      }

      const averageX = sumX / coordinatesCount;
      const averageY = sumY / coordinatesCount;

      const marker = { lat: averageY, lng: averageX };

      return polygonCoordinates.map((coord) => ({
        lat: coord[1],
        lng: coord[0],
      }));
    },
    onPlaceChanged(place) {
      if (place.geometry) {
        const { location } = place.geometry;

        this.mapCenter = {
          lat: location.lat(),
          lng: location.lng(),
        };

        this.mapZoom = 10;
      }
    },
  },
};
</script>

<style scoped>
.my-autocomplete {
  height: 36px;
  padding: 6px 10px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 4px;
  border: 1px solid #ccc;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.my-autocomplete {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.my-autocomplete {
  padding: 6px 10px;
  cursor: pointer;
}
.my-autocomplete .pac-icon-search {
  color: #6c757d;
}

.my-autocomplete .pac-icon-clear {
  color: #6c757d;
  cursor: pointer;
}

.my-autocomplete .pac-icon-clear:hover {
  color: #dc3545;
}
</style>
